<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="60%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-form
                            class="cardWrap__fromArea"
                            ref="point_class_form"
                            v-model="valid"
                            :lazy-validation="lazy"
                        >
                            <v-container>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">コード</div>
                                        <v-text-field
                                            class="px-3"
                                            disabled
                                            v-model="from_set_data.point_type"
                                        />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">コード名</div>
                                        <v-text-field
                                            class="px-3"
                                            disabled
                                            v-model="from_set_data.point_type_name"
                                        />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">表示名</div>
                                        <v-text-field
                                            class="px-3"
                                            :rules="[rules.required, rules.max_length_point_type_display]"
                                            v-model="from_set_data.point_type_display"
                                            autofocus
                                            maxlength="20"
                                            ref="input1"
                                            @keyup.enter="enterMove"
                                        />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">詳細内容</div>
                                        <v-text-field
                                            class="px-3"
                                            v-model="from_set_data.detail"
                                            maxlength="256"
                                            ref="input2"
                                        />
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                        <v-btn color="green darken-4" text @click="validateCheck">変更</v-btn>
                    </v-card-actions>
                    <ChangeOverlay
                        @processing="updatePointType"
                        @cancel="changeOverlay = !changeOverlay"
                        :process-result="process"
                        :overlay-switch="changeOverlay"
                        page-name="ポイント区分"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '../../../../components/module/CardTitle';
import { UPDATE_POINT_TYPE } from '../../../../constants/master';
import ChangeOverlay from '../overlay/ChangeOverlay';
import { InputPagesMixin } from './../mixin/InputPagesMixin';

export default {
    components: {
        CardTitle,
        ChangeOverlay
    },
    mixin: [InputPagesMixin],
    props: ['editInfo'],
    data () {
        return {
            pageName: 'ポイント区分',
            // 変更確認用ポップアップ表示に関する制御値
            changeOverlay: false,
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: 'ポイント区分変更',
            // 画面のモード指定
            // [値：checkData = 会員情報参照],[値：addMember = 会員追加],[値：changeData = 情報変更]
            modeStatus: 'changeMode',
            // 必須項目に関するチェック値
            valid: true,
            // モーダル画面表示制御値
            dialog: false,
            // バリデーションチェック値
            lazy: true,
            // 入力値管理用
            from_set_data: {
                // id
                id: '',
                // コード
                point_type: '',
                // コード名
                point_type_name: '',
                // 表示名
                point_type_display: '',
                // 詳細内容
                detail: ''
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: ''
            },
            rules: {
                // 氏名（姓）バリデーション
                required: value => !!value || this.$t('error.validation.required.any'),
                max_length_point_type_display: value => value.length <= 20 || this.$t('error.validation.length.pointTypeDisplay')
            }
        };
    },
    computed: {
        EmptyResult: function () {
            return this.process.result === '';
        },
        NotEmptyResult: function () {
            return this.process.result !== '';
        }
    },
    watch: {
        editInfo () {
            this.from_set_data.id = this.editInfo.id;
            this.from_set_data.point_type = this.editInfo.point_type;
            this.from_set_data.point_type_name = this.editInfo.point_type_name;
            this.from_set_data.point_type_display = this.editInfo.point_type_display;
            this.from_set_data.detail = this.editInfo.detail;
        },
        result () {
            if (this.process.result === 1) {
                this.process.resultText = this.$t('result.success.change');
            } else if (this.result === 0) {
                this.process.resultText = this.$t('result.error.change');
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.process.result = '';
            this.process.resultText = '';
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * ポイント区分更新
         * ---------------------------------------------- */
        updatePointType () {
            this.$apollo.mutate({
                mutation: UPDATE_POINT_TYPE,
                variables: {
                    id: this.from_set_data.id,
                    point_type_display: this.from_set_data.point_type_display,
                    detail: this.from_set_data.detail
                }
            }).then(res => {
                this.process.result = res.data.UpdatePointType.result;
                this.CloseModal();
            }).catch(error => {
                this.process.result = 0;
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.point_class_form.validate()) {
                this.changeOverlay = true;
            }
        },
        /** ----------------------------------------------
         * エンターキーで入力欄を移動させる処理
         * ---------------------------------------------- */
        enterMove () {
            this.$refs.input2.focus();
        },
        /** ----------------------------------------------
         * 親画面にて「変更」ボタン押下時の処理
         * 親画面から渡ってきたデータを各項目に渡す
         * @param val モーダル画面の表示用制御値
         * ---------------------------------------------- */
        ChangeModal (val) {
            this.Initialize();
            this.dialog = val;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$emit('refresh-event');
            this.Initialize();
        }
    }
};
</script>
